const ENTITIES_BY_BOX_TYPE_ID = {
  31: ['supplier'],
  35: ['supplier'],
  36: ['supplier', 'article'],
  37: ['brand', 'product']
}

const ENTITY_TYPE_IDS = {
  COMPANY: 1,
  SUPPLIER: 2,
  ARTICLE: 3,
  BRAND: 4,
  PRODUCT: 5,
}

const INITIAL_STATE ={
  31: {
    value: '',
    autocomplete_module_replace_fields: [
      {
        replace_field: 'supplier_co2_footprint',
        value: ''
      },
      {
        replace_field: 'supplier_address_street',
        value: ''
      },
      {
        replace_field: 'supplier_address_street_number',
        value: ''
      },
      {
        replace_field: 'supplier_city',
        value: ''
      },
      {
        replace_field: 'supplier_zip_code',
        value: ''
      },
      {
        replace_field: 'supplier_location',
        value: ''
      },
      {
        replace_field: 'supplier_country',
        value: ''
      },
      {
        replace_field: 'supplier_geolocation',
        value: ''
      },
      {
        replace_field: 'supplier_picture_1',
        value: ''
      },
      {
        replace_field: 'supplier_picture_2',
        value: ''
      },
      {
        replace_field: 'supplier_picture_3',
        value: ''
      },
      {
        replace_field: 'supplier_picture_4',
        value: ''
      }
    ]
  },
  35: {
    value: '',
    autocomplete_module_replace_fields: [
      {
        replace_field: 'supplier_address_street',
        value: ''
      },
      {
        replace_field: 'supplier_address_street_number',
        value: ''
      },
      {
        replace_field: 'supplier_city',
        value: ''
      },
      {
        replace_field: 'supplier_zip_code',
        value: ''
      },
      {
        replace_field: 'supplier_location',
        value: ''
      },
      {
        replace_field: 'supplier_country',
        value: ''
      },
      {
        replace_field: 'supplier_geolocation',
        value: ''
      },
      {
        replace_field: 'supplier_picture_1',
        value: ''
      },
      {
        replace_field: 'supplier_picture_2',
        value: ''
      },
      {
        replace_field: 'supplier_picture_3',
        value: ''
      },
      {
        replace_field: 'supplier_picture_4',
        value: ''
      },
      {
        replace_field: 'supplier_video_url',
        value: ''
      }
    ]
  },
  36: {
    value: '',
    autocomplete_module_replace_fields: [
      {
        replace_field: 'supplier_address_street',
        value: ''
      },
      {
        replace_field: 'supplier_address_street_number',
        value: ''
      },
      {
        replace_field: 'supplier_city',
        value: ''
      },
      {
        replace_field: 'supplier_zip_code',
        value: ''
      },
      {
        replace_field: 'supplier_location',
        value: ''
      },
      {
        replace_field: 'supplier_country',
        value: ''
      },
      {
        replace_field: 'supplier_geolocation',
        value: ''
      },
      {
        replace_field: 'supplier_picture_1',
        value: ''
      },
      {
        replace_field: 'supplier_picture_2',
        value: ''
      },
      {
        replace_field: 'supplier_picture_3',
        value: ''
      },
      {
        replace_field: 'supplier_picture_4',
        value: ''
      },
      {
        replace_field: 'supplier_video_url',
        value: ''
      }
    ]
  },
}

const MANDATORY_FIELDS = {
  31: [
    'supplier_address_street',
    'supplier_address_street_number',
    'supplier_city',
    'supplier_zip_code',
    'supplier_location',
    'supplier_country',
    'supplier_geolocation',
    'supplier_co2_footprint',
  ],
  35: [
    'supplier_address_street',
    'supplier_address_street_number',
    'supplier_city',
    'supplier_zip_code',
    'supplier_location',
    'supplier_country',
    'supplier_geolocation',
  ],
  36: [
    'supplier_address_street',
    'supplier_address_street_number',
    'supplier_city',
    'supplier_zip_code',
    'supplier_location',
    'supplier_country',
    'supplier_geolocation',
  ],
}

const getInitialStateByBoxTypeId = (boxTypeId = 31) => {
  return JSON.parse(JSON.stringify(INITIAL_STATE[Number(boxTypeId)] ?? INITIAL_STATE[31]));
}

const getMandatoryFieldsByBoxTypeId = (boxTypeId = 31) => {
  return MANDATORY_FIELDS[Number(boxTypeId)] ?? MANDATORY_FIELDS[31]
}

const cantSeeNamedEntitiesByBoxTypeId = (boxTypeId) => {
  return ENTITIES_BY_BOX_TYPE_ID[Number(boxTypeId)] ? false : true;
}

const getEntitiesByBoxIdByBoxTypeId = (boxTypeId) => {
  return ENTITIES_BY_BOX_TYPE_ID[Number(boxTypeId)] ?? [];
};

const getEntityIdByName = (entityName) => {
  return ENTITY_TYPE_IDS[entityName.toUpperCase()];
}

export { getInitialStateByBoxTypeId, getMandatoryFieldsByBoxTypeId, cantSeeNamedEntitiesByBoxTypeId, getEntitiesByBoxIdByBoxTypeId, getEntityIdByName }